/**
 * Get the closest component identifier of an DOM element data-componentid or data-component-id (former)
 *
 * @param {Element} element
 * @returns {string | null}
 */
export default function getClosestComponentID(element) {
  const closest = element?.closest('[data-cid], [data-componentid], [data-component-id]');
  return closest ? (closest.dataset.cid ?? closest.dataset.componentid ?? closest.dataset.componentId) : null;
}
